export const cleanPhoneNumber = (phoneNumber) =>
  phoneNumber?.replace(/\D/g, '');
